import React from 'react'
import { Box } from '@mui/material'

function Header() {
  return (
    <>
      <Box
        sx={{
          height: 80,
          display: { xs: 'none', sm: 'block' },
          marginTop: { sm: -17, md: -14, lg: -12 },
          background: '#ffffff',
          marginLeft: -3.5,
          marginBottom: 2,
          pointerEvents: 'none'
        }}></Box>
    </>
  )
}

export default Header
